import { NgModule } from '@angular/core';
import { Routes, RouterModule, CanActivate } from '@angular/router';
import { Router,ActivatedRoute} from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { AuthgaurdService as AuthGuard } from './core/security/authgaurd.service';
import { HeaderComponent } from './shared/header/header.component';
import { AboutComponent } from './about/about.component';
import { OrganizationComponent } from './pages/organization/organization.component';
import { GateComponent } from './pages/gate/gate.component';
import {UserComponent  } from './pages/users/user/user.component';
import {UserRoleDetailsComponent  } from './pages/users/user-role-details/user-role-details.component';
import {UsersDetailsComponent  } from './pages/users/users-details/users-details.component';
import {AboutUsComponent  } from './pages/users/about-us/about-us.component';
import {UserDashboardComponent  } from './pages/users/user-dashboard/user-dashboard.component';
import { UserLandingPageComponent } from "./pages/users/user-landing-page/user-landing-page.component";
import { UserEventPageComponent } from "./pages/users/user-event-page/user-event-page.component";
import { AboutUsViewComponent } from './pages/users/about-us-view/about-us-view.component';
import { UserRoleViewComponent } from './pages/users/user-role-view/user-role-view.component';
import { RichTextAreaComponent } from './pages/rich-text-area/rich-text-area.component';
import { DinningTimeComponent } from './pages/users/dinning-time/dinning-time.component';
let routerRedirect = '/login';
if (window.localStorage.getItem('m_ind_token') != undefined || window.localStorage.getItem('m_ind_token') != null || window.localStorage.getItem('m_ind_token') != 'undefined') {
  routerRedirect = '/dashboard';
}
const routes: Routes = [
  { path: 'about', component: AboutUsComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent },
  { path: 'event', component: OrganizationComponent, canActivate: [AuthGuard] },
  { path: 'gate', component: GateComponent, canActivate: [AuthGuard] },
  { path: 'user', component: UserComponent, canActivate: [AuthGuard] },
  { path: 'assign-role', component: UserRoleDetailsComponent, canActivate: [AuthGuard] },
  { path: ':name/user-details/:id', component: UsersDetailsComponent, canActivate: [AuthGuard] },
  { path: 'dashboard', component: UserDashboardComponent, canActivate: [AuthGuard] },
  { path: 'dining-time', component: DinningTimeComponent, canActivate: [AuthGuard] },
  { path: 'forgot-pass', component: ForgotPasswordComponent },
  { path: 'event-details/:id', component: UserLandingPageComponent },
  { path: 'events/:id', component: UserEventPageComponent },
  { path: 'about-details/:id', component: AboutUsViewComponent },
  { path: 'role-details/:id', component: UserRoleViewComponent,canActivate: [AuthGuard] },
  { path: 'change-pass/:id', component: ChangePasswordComponent },
  { path: 'rich-text-editor', component: RichTextAreaComponent },
  { path: '**', redirectTo: routerRedirect, pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
